export default __webpack_public_path__ + "static/media/sikovne-rucky.fdfcd8ef.svg";